import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';

const CARD_SX = {
  position: 'relative',
  zIndex: 1,
  borderRadius: 2,
  backgroundColor: 'var(--mui-palette-background-brandSubtle)',
  px: 1.5,
  py: 1.25,
} as const;

const InterruptionListCardLayout = ({ children }: PropsWithChildren) => (
  <Box component="article" sx={CARD_SX}>
    {children}
  </Box>
);

export default InterruptionListCardLayout;
